<template>
	<div>
		<vxe-grid ref="list" v-if="list_gridOptions" v-bind="list_gridOptions"
			@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 600
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '新增',
						status: 'primary',
						code: 'add'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				}
				gridOptions.columns = [{
						field: 'province',
						title: '省份',
						editRender: {
							name: '$emun',
							props: {
								name:'city'
							},
							events: {
								
							}
						},
					}, {
						field: 'warehouseid',
						title: '仓库',
						editRender: {
							name: '$warehouse',
							props: {
								name:''
							},
							events: {
								
							}
						},
					}, {
						field: 'parcel',
						title: '物流方式',
						editRender: {
							name: '$emun',
							props: {
								name:'parceltype'
							},
							events: {
								
							}
						},
					}, {
						field: 'getday',
						title: '到仓天数',
						editRender: {
							name: '$inputNumber',
							props: {
								precision:0
							},
							events: {

							}
						},
					}, {
						field: 'postfee',
						title: '费用',
						editRender: {
							name: '$inputNumber',
							props: {
								precision:2
							},
							events: {

							}
						},
					}, {
						field: 'additionalfeepercent',
						title: '附加费用占比',
						editRender: {
							name: '$inputNumber',
							props: {
								precision:2
							},
							events: {

							}
						},
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 65,
						slots: {
							default: ({row}) => {
								return [<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.delete(row)}}>删除</el-button>]
							}
						}
					}
				]
				gridOptions.formConfig = false
				// gridOptions.editRules = {
				// 	c: [{
				// 		required: true
				// 	},{
				// 		validator({cellValue,row}){
				// 			return new Promise((resolve,reject)=>{
				// 				if( true ){
				// 					reject(new Error('自定义错误'))
				// 				}else{
				// 					resolve()
				// 				}
								
				// 			})
				// 		}
				// 	}]
				// }
			},
			list() {
				let list = this.data.find((item)=>{
					return item.type == 'express'
				})
				// if(list){
				// 	list.config = list.config.map((item)=>{
				// 		for(let i in item){
				// 			item[i] = parseFloat(item[i])
				// 		}
				// 		return item
				// 	})
				// }
				return new Promise((resolve) => {
					resolve({
						list:list?list.config:[]
					})
				})
			},
			getgrid(){
				return this.$refs.list
			},
			add(){
				this.getgrid().insert({})
			},
			delete(row){
				this.getgrid().remove(row)
			},
			submit() {
				let tableData = this.getgrid().getTableData().tableData
				tableData = tableData.map((item) => {
					const newRow = { ...item }
					delete newRow._X_ROW_KEY
					delete newRow._X_ROW_CHILD
					return newRow
				})
				return tableData
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k]/1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i]/1000
					}
				}
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>